export const SET_PATHNAME = "SET_PATHNAME";
export const SET_COMPLETEDSTAGES = "SET_COMPLETEDSTAGES";
export const SET_CURRENTSTAGE = "SET_CURRENTSTAGE";

export const setPathName = (data: any) => {
  return {
    type: SET_PATHNAME,
    payload: data,
  };
};
export const setCompletedStages = (data: any) => {
  return {
    type: SET_COMPLETEDSTAGES,
    payload: data,
  };
};
export const setCurrentStage = (data: any) => {
  return {
    type: SET_CURRENTSTAGE,
    payload: data,
  };
};
